import { InputLabel } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React from 'react';
import { useTranslation } from 'react-i18next';

const BillingPeriodSelect = ({ noAllOption = false, periods, value, onChange, error, helperText, ...selectProps }) => {
  const { t } = useTranslation();

  const handleChange = event => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl error={error}>
      <InputLabel>{t('billing.billingPeriod', 'Billing Period')}</InputLabel>
      <Select
        {...selectProps}
        label={t('billing.billingPeriod', 'Billing Period')}
        value={value != null && value != undefined ? value : !noAllOption ? 'all' : ''}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': t('billing.selectBillingPeriod', 'Select Billing Period') }}
        sx={{ minWidth: '140px' }}
      >
        <MenuItem value="" disabled>
          {t('billing.selectBillingPeriod', 'Select Billing Period')}
        </MenuItem>
        {!noAllOption && <MenuItem value="all">{t('billing.allPeriods', 'All Periods')}</MenuItem>}
        {periods.map(period => {
          return (
            <MenuItem key={period} value={period}>
              {period}
            </MenuItem>
          );
        })}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default BillingPeriodSelect;
